/**
 * Base URL of the MotoGo backend. Override in production via the `VITE_API_BASE_URL`
 * env var at build time; defaults to the .NET dev profile (`http://localhost:5144`).
 */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:5144';

/**
 * Pseudo-auth key the backend requires on every request (header for HTTP, query string
 * for the SignalR WebSocket). Set per env via `VITE_DEBUG_KEY` at build time; empty
 * string in unconfigured dev means every call will 401 -- intentional, set the value
 * in `apps/pwa/.env.development` (or a `.env.local`) to use the API locally.
 */
export const DEBUG_KEY: string = import.meta.env.VITE_DEBUG_KEY ?? '';

const DEBUG_KEY_HEADER = 'X-Debug-Key';

/**
 * `fetch` wrapper that attaches the `X-Debug-Key` header automatically and includes
 * credentials so the session cookie is sent on cross-origin calls (PWA on
 * motogo.<env>.* → API on motogo.api.<env>.*). Use for any call to our backend;
 * external APIs (Overpass etc.) should still use raw `fetch`.
 */
export function motogoFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  headers.set(DEBUG_KEY_HEADER, DEBUG_KEY);
  return fetch(input, { ...init, credentials: 'include', headers });
}
